export default __webpack_public_path__ + "static/media/uploading.dabcc656.svg";